import React, {memo} from 'react'
import cx from 'classnames'

/* Styles */
import s from './ComparedProducts.scss'

const ComparedProductsPlaceholder = memo(({className}) => (
  <section className={cx(s.placeholder, className)}>
    <div className={s.titlePlaceholder}></div>
    <div className={s.productCardPlaceholderWrapper}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div className={s.tablePlaceholder}></div>
  </section>
))

export default ComparedProductsPlaceholder
